import {ArchivableItemREST, NOT_ARCHIVED_PURPOSE_STRING} from 'archive/ArchiveConstants';
import isArchived from 'archive/isArchived';
import {Optional} from 'util/Types';

/*
 * Given a list of items and a list of archive purposes, return the list filtered to archived items with those
 * purposes.
 */
export function filterItemsToPurposes<T extends ArchivableItemREST>(
  items: Optional<Array<T>>,
  purposes: Array<string>
): Array<T> | null {
  if (items == null) {
    return null;
  }
  return items.filter((item) => {
    if (!isArchived(item) && purposes.includes(NOT_ARCHIVED_PURPOSE_STRING)) {
      return true;
    } else if (isArchived(item)) {
      if (item.archiveRecord != null && purposes.includes(item.archiveRecord.purpose)) {
        return true;
      }
    }
    return false;
  });
}
